import { LANG } from "@/lib/store/features/lang/langSlice";

export type CountryType = {
  code: LANG;
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  flag: any;
};

export const countries: CountryType[] = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "mg", name: "Malagasy", flag: "🇲🇬" },
  { code: "dyu", name: "Dioula", flag: "🇲🇱" },
  { code: "wo", name: "Wolof", flag: "🇸🇳" },
  { code: "ba", name: "Baoule", flag: "🇨🇮" },
];
